// Content for the inner pages. Demo text: replace with real SDL content.

export const about = {
  hero: { title: 'Where innovation meets the needs of the real world.', text: 'Engineering with empathy, delivering with precision.' },
  who: [
    'Sheba Digital Limited is a technology company under Sheba Group, specializing in custom software, web and mobile applications, cloud solutions and digital transformation. Our engineers, designers and analysts partner with organizations to automate workflows, modernize systems and create seamless digital experiences.',
    'We believe technology should simplify lives, not complicate them. Every solution we build is crafted with clarity, performance and user experience at the forefront.',
  ],
  mission: 'Empowering organizations with dependable software solutions and skilled technology teams.',
  vision: 'To be a trusted technology partner that helps build a smarter, more connected business ecosystem.',
  values: [
    { icon: 'shield', title: 'Integrity', text: 'We deliver what we promise.' },
    { icon: 'spark', title: 'Quality', text: 'We focus on the details that make products truly exceptional.' },
    { icon: 'loop', title: 'Innovation', text: 'We embrace new ideas and modern technologies.' },
    { icon: 'building', title: 'Responsibility', text: 'We build solutions that are secure, ethical and sustainable.' },
    { icon: 'team', title: 'Customer Success', text: 'Your outcomes define our success.' },
  ],
  // Demo timeline. Replace years and text with SDL's real milestones.
  journey: [
    { year: '[Year]', title: 'The Beginning', text: 'Demo milestone: how Sheba Digital Limited started its journey.' },
    { year: '[Year]', title: 'Expanding Innovation', text: 'Demo milestone: first large-scale platform delivered to a client.' },
    { year: '[Year]', title: 'Strengthening Our Footprint', text: 'Demo milestone: growth into new industries and services.' },
    { year: '[Year]', title: 'Building Our Own Products', text: 'Demo milestone: in-house product development begins.' },
    { year: '[Year]', title: 'Scaling Across Industries', text: 'Demo milestone: education, business and payment solutions grow.' },
    { year: '[Year]', title: 'A Year of Growth', text: 'Demo milestone: expanded team and cloud capabilities.' },
  ],
};

export const servicePoints = [
  ['Tailored to your business processes', 'Scalable, future-ready architecture', 'Secure and reliable by design', 'Seamless integration with existing tools'],
  ['Responsive, modern user interfaces', 'API-first, scalable backends', 'Performance and accessibility focus', 'Cloud-ready deployment'],
  ['Android and iOS native applications', 'Flutter cross-platform applications', 'Store launch support', 'API, backend and cloud integration'],
  ['Student, teacher and admin portals', 'Results, attendance and fee management', 'Notifications and reporting', 'Built for schools, colleges and universities'],
  ['Workflow and approval automation', 'Automated reports and dashboards', 'Payment and communication automation', 'Fewer manual steps, fewer errors'],
  ['Cloud deployment and migration', 'Infrastructure architecture', 'Monitoring and alerting', 'Scalability and performance tuning'],
  ['Payment gateway integration', 'Transaction processing and reconciliation', 'Secure, auditable flows', 'Digital service platforms'],
  ['Industry-specific platform design', 'End-to-end delivery', 'Modular, extensible architecture', 'Long-term support and evolution'],
];

export const productsPage = {
  hero: { title: 'Our Product Suite', text: 'A comprehensive set of solutions designed to automate workflows, improve efficiency, and drive smarter decision-making.', button: 'Explore Products' },
  featured: {
    label: 'Featured Solution',
    title: 'Digital Platforms, Built Around You',
    text: 'Launch secure, scalable digital platforms built around your organization, with ongoing support after go-live.',
    button: 'Request Demo',
    badges: ['Secure', 'Scalable', 'Cloud-ready', 'Supported'],
  },
  whyTitle: 'Why Choose Our Products',
  whyText: 'Solutions built with engineering discipline, designed to fit your organization and to grow with it.',
  why: [
    { icon: 'shield', title: 'Enterprise-Grade Security', text: 'Security considered at every layer to protect your data.' },
    { icon: 'layers', title: 'Seamless Integration', text: 'Easily integrate with existing systems and third-party applications.' },
    { icon: 'loop', title: 'Scalable & Flexible', text: 'Solutions that grow with your business and adapt to changing needs.' },
    { icon: 'spark', title: 'Modern & User-Friendly', text: 'Intuitive interfaces that improve adoption and productivity.' },
    { icon: 'support', title: 'Reliable Support', text: 'A dedicated team to help you every step of the way.' },
  ],
};

export const portfolioPage = {
  hero: { title: 'Our Work Speaks for Itself', text: 'Innovative, scalable, and user-centric digital solutions built for our clients.', button: "Let's talk" },
  title: 'Our Projects',
  text: 'A collection of projects delivering smart, scalable and future-ready solutions across multiple industries. (Demo content.)',
};

export const career = {
  hero: { title: 'Join the team behind the future of work', text: 'Build software that organizations depend on, with people who care about quality.' },
  whyTitle: 'Why Work With Us?',
  whyText: 'A workplace where engineers, designers and analysts are trusted to do their best work.',
  why: [
    { icon: 'spark', title: 'Innovative Culture', text: 'We celebrate fresh ideas. Your creativity and passion for technology will thrive.' },
    { icon: 'loop', title: 'Growth Opportunities', text: 'We invest in your professional development and help you accelerate your career.' },
    { icon: 'clock', title: 'Work-Life Balance', text: 'We value your personal time and well-being.' },
    { icon: 'team', title: 'Collaborative Team', text: 'Work alongside talented peers in a supportive, cooperative environment.' },
  ],
  perksTitle: 'Perks & Benefits',
  perksText: 'What you can expect when you join the team.',
  perks: [
    'Competitive Salary', 'Performance Bonus', 'Festival Bonus', 'Annual Leave', 'Casual & Sick Leave',
    'Maternal and Parental Leave', 'Friendly Environment', 'Lunch Facilities', 'Knowledge Sharing Sessions',
    'Quarterly Team Outings', 'Training and Learning Materials', 'Unlimited Tea & Coffee',
  ],
  openingsNote: { title: "We're quiet right now, but growing", text: "Don't see your role? Amazing talent is always welcome. Share your details below and we'll reach out when a matching opportunity opens." },
};

export const contactPage = {
  hero: { title: "Let's build something meaningful together", text: 'Tell us about your project, idea or digital challenge and our team will get back to you.' },
};
